import { render, staticRenderFns } from "./CooperationIcon.vue?vue&type=template&id=3708167e&scoped=true&"
import script from "./CooperationIcon.vue?vue&type=script&lang=js&"
export * from "./CooperationIcon.vue?vue&type=script&lang=js&"
import style0 from "./CooperationIcon.vue?vue&type=style&index=0&id=3708167e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3708167e",
  null
  
)

export default component.exports